(ns frontend.view.modals.bulk-edit-entity.events
  (:require
   [frontend.actions.entity :as entity-actions]
   [common.util :as cu]
   [common.schema.registry :as registry]
   [frontend.state.current-session :as session]))

(defn- normalize-field-attribute
  [attribute]
  (if (sequential? attribute)
    (last attribute)
    attribute))

(defn execute-bulk-edit!
  [{:keys [state entity-type selected-entity-ids
           allow-target-asset-editing? target-asset-type target-asset-keyword
           success-callback! error-callback! continue?]}]
  (swap! state dissoc :error?)
  (let [selected-field (normalize-field-attribute (:selected-field @state))]

    (if (= selected-field :oppo/status)
      (let [new-status (:status @state)]
        (case new-status
          :oppo.status/on-hold
          (let [internal-comment (:internal-comment @state)
                months (:months @state)
                until (:until @state)

                data (merge
                      {:entity-ids  selected-entity-ids
                       :entity-type entity-type
                       :months      months}
                      (when (= months 0)
                        {:until until})
                      (when-not (cu/empty-value? internal-comment)
                        {:internal-comment internal-comment}))]
            (entity-actions/*->bulk-put-on-hold
             data
             (partial success-callback! continue?)
             error-callback!))

          :oppo.status/passed
          (let [pass-reason-id (:pass-reason @state)
                internal-comment (:internal-comment @state)
                secondary-pass-reason-id (:pass-reason-secondary @state)
                broken-deal-currency (:broken-deal-currency @state)
                broken-deal-expenses (:broken-deal-expenses @state)
                data (merge
                      {:entity-ids     selected-entity-ids
                       :entity-type    entity-type
                       :pass-reason-id pass-reason-id}
                      (when-not (cu/empty-value? internal-comment)
                        {:internal-comment internal-comment})
                      (when-not (cu/empty-value? secondary-pass-reason-id)
                        {:secondary-pass-reason-id secondary-pass-reason-id})
                      (when-not (cu/empty-value? broken-deal-currency)
                        {:broken-deal-currency broken-deal-currency})
                      (when-not (cu/empty-value? broken-deal-expenses)
                        {:broken-deal-expenses broken-deal-expenses}))]

            (entity-actions/*->bulk-pass
             data
             (partial success-callback! continue?)
             error-callback!))

          :oppo.status/ok
          (let [data {:entity-ids  selected-entity-ids
                      :entity-type entity-type
                      :attribute   selected-field
                      :value       :oppo.status/ok
                      :action      :replace}]
            (entity-actions/*->bulk-edit
             data
             (partial success-callback! continue?)
             error-callback!))

          (js/console.log "Status change not implemented for " new-status)))

      (let [tenant-schema @session/tenant-schema
            selected-field-schema
            (registry/get-field-schema tenant-schema selected-field)

            field-data-type (:field/data-type selected-field-schema)

            action-target-entity-type
            (:containing-entity-type selected-field-schema)

            value (if (= field-data-type :data.type/boolean)
                    (boolean (:value @state))
                    (:value @state))

            ; Clearing a boolean value causes errors in db cas operations,
            ; replace with false value instead of clearing
            action (if (and (= field-data-type :data.type/boolean)
                            (= (:action-type @state) :clear-all))
                     :replace
                     (:action-type @state))

            entity-ids (cond
                         (and allow-target-asset-editing?
                              (or (= action-target-entity-type target-asset-type)
                                  (= action-target-entity-type :asset)))
                         (->> selected-entity-ids
                              (map (fn [entity-id]
                                     (-> entity-id
                                         (session/get-entity)
                                         (get target-asset-keyword)))))

                         :else selected-entity-ids)

            data {:entity-ids  entity-ids
                  :entity-type action-target-entity-type
                  :attribute   selected-field
                  :value       value
                  :action      action}]
        #_(js/console.log "bulk edit data " data)

        (entity-actions/*->bulk-edit
         data
         (partial success-callback! continue?)
         error-callback!)))))
